import classNames from 'classnames';
import {Image} from '@shopify/hydrogen';

export const ReviewCard = ({
  quote,
  name,
  title,
  image,
  logo,
  url,
}: {
  quote: string;
  name: string;
  title?: string;
  image: string;
  logo: string;
  url: string;
}) => {
  return (
    <div
      className={classNames(
        'flex',
        'flex-col',
        'md:flex-row',
        'justify-between',
        'items-center',

        'h-[33.5rem]',
        'md:h-auto',
        'md:w-[620px]',
        'min-[821px]:w-[665px]',
        'lg:w-[880px]',
        'px-8',
        'py-16',
        'md:p-12',
        'lg:p-20',
        'my-0',
        'mb-3',
        'mx-auto',

        'rounded-[20px]',
        'border-[1px]',
        'border-black',
        'shadow-10px',

        'bg-white',
      )}
    >
      <Image
        className={classNames(
          'w-36',
          'md:w-auto',
          'md:max-h-[230px]',
          'lg:max-h-[260px]',
          'aspect-square',

          'border-2',
          'border-[#e0e0e0]',
          'border-solid',
          'rounded-[9px]',
          'md:rounded-[30px]',
        )}
        alt={`profile picture of ${url}`}
        src={`${image}?width=330&height=330`}
        srcSet={`${image}?width=330&height=330, ${image}?width=660&height=660 2x, ${image}?width=990&height=990 3x`}
        width={330}
        height={330}
      />
      <div
        className={classNames(
          'text-center',
          'md:text-left',

          'flex',
          'flex-col',
          'items-center',
          'md:items-start',
          'md:ml-7',
          'lg:ml-16',
        )}
      >
        <div
          className={classNames(
            'mx-auto',
            'my-0',
            'mt-6',
            'md:my-auto',

            'font-bold',
            'text-[16px]',
            'leading-[19px]',
            'lg:text-[22px]',
            'lg:leading-[26px]',
          )}
        >
          {`"${quote}"`}
        </div>
        <div
          className={classNames(
            'text-[14px]',
            'leading-[21px]',
            'mt-5',
            'font-bold',
          )}
        >
          {name}
        </div>
        {Boolean(title) && (
          <div className={classNames('text-[14px]', 'leading-[21px]')}>
            {title}
          </div>
        )}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          target="_blank"
          className={classNames(
            'flex',
            'items-center',
            'gap-2',
            'md:gap-4',
            'text-[13px]',
            'leading-[15px]',
            'md:text-[15px]',
            'md:leading-[19px]',

            'bg-[#f4ecff]',
            'rounded-[31.5px]',
            'transition',
            'shadow-10px',
            'max-[350px]:shadow-5px',
            'max-[350px]:ml-[4px]',
            'hover:shadow-none',
            'hover:translate-x-[-10px]',
            'hover:translate-y-[10px]',

            'w-[254px]',
            'h-[55px]',
            'md:w-[320px]',
            'p-[5px]',
            'mt-5',
          )}
          href={url}
        >
          <Image
            className={classNames(
              'w-[30px]',
              'md:w-[40px]',
              'ml-[5px]',
              'md:ml-[15px]',

              'font-[Roboto]',
              'rounded-full',
            )}
            alt={`profile picture of ${url}`}
            src={logo}
            width={40}
            height={40}
          />
          <div
            className={classNames('md:flex', 'md:flex-row')}
          >{`linkpop.com${url}`}</div>
        </a>
      </div>
    </div>
  );
};
